<script lang="ts">
	import type { WidgetState } from '../lib/widget.svelte';

	let { widget, tips = [] }: { widget: WidgetState; tips?: string[] } = $props();

	// Tips de fotografía/iluminación que rotan mientras baja el modelo (engagement)
	const DEFAULT_TIPS = [
		'💡 Buscá luz natural de frente: las ventanas son tu mejor aliada.',
		'📐 Mantené la cámara a la altura de los ojos para un ángulo favorecedor.',
		'🚫 Evitá la luz directa desde arriba: genera sombras duras en el rostro.',
		'😊 Una sonrisa natural funciona mejor que una pose forzada.',
		'🎯 Dejá espacio alrededor de tu cabeza: después podés reencuadrar.',
		'🧍 Un fondo despejado ayuda a que el recorte con IA quede perfecto.'
	];

	// Guía rápida personalizada vía atributo `tips` (separada por "|")
	let activeTips = $derived(tips.length > 0 ? tips : DEFAULT_TIPS);

	let tipIndex = $state(0);

	$effect(() => {
		const count = activeTips.length;
		const interval = setInterval(() => {
			tipIndex = (tipIndex + 1) % count;
		}, 3500);
		return () => clearInterval(interval);
	});
</script>

<div class="ss-loader">
	<div class="ss-spinner"></div>
	<h3>Preparando el estudio de fotos…</h3>

	{#key tipIndex}
		<p class="ss-tip">{activeTips[tipIndex % activeTips.length]}</p>
	{/key}

	<div class="ss-progress">
		<div style="width: {widget.modelReady ? 100 : widget.modelProgress}%"></div>
	</div>
	<p class="ss-tip" style="min-height:auto">
		{widget.modelReady ? 'Motor de IA listo ✓' : `Descargando motor de IA… ${widget.modelProgress}%`}
	</p>
</div>
